import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  makeStyles,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  InputAdornment,
  IconButton,
} from "@material-ui/core";
import AdminBannerImage from "../images/parikshadoadminpanel/adminbanner.png";
import PhoneIcon from "@material-ui/icons/Phone";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";
import { encryptData } from "../../crypto";

const useStyles = makeStyles((theme) => ({
  card: {
    width: "100vw",
    height: "100vh",
    margin: 0,
    display: "flex",
    position: "relative",
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(225, 225, 225, 1)",
      borderWidth: "1px",
    },
    "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "rgba(225, 225, 225, 1)",
    },
  },
  versionText: {
    position: "absolute",
    bottom: "10px",
    right: "10px",
    fontSize: "0.75rem",
    color: "#9E9E9E",
  },
  backgroundContainer: {
    flex: 1,
    background: `url(${AdminBannerImage}) center/cover no-repeat`,
    position: "relative",
  },
  textContainer: {
    position: "absolute",
    top: "18%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    textAlign: "center",
    color: "white",
    whiteSpace: "nowrap",
  },
  heading: {
    fontFamily: "Plus Jakarta Sans",
    fontWeight: "800",
    fontSize: "38px",
    color: "rgba(255, 255, 255, 1)",
  },
  Subheading: {
    fontFamily: "Plus Jakarta Sans",
    fontWeight: "800",
    fontSize: "22px",
    lineHeight: "40px",
    color: "rgba(255, 205, 71, 1)",
  },
  content: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  additionalCard: {
    width: "450px",
    height: "530px",
    backgroundColor: "rgba(254, 254, 254, 1)",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
    position: "relative",
    top: "50%",
    transform: "translateY(-50%)",
    display: "flex",
  },
  logo: {
    width: "auto",
    height: "auto",
    margin: "40px auto 0",
  },
  signInText: {
    fontFamily: "Satoshi",
    fontSize: "23px",
    color: "rgba(47, 47, 47, 1)",
    fontWeight: "700",
    margin: "20px auto 0",
  },
  inputContainer: {
    width: "80%",
    margin: "30px auto 0",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  },
  inputField: {
    margin: "15px 0",
    width: "100%",
    borderRadius: "6px",
    backgroundColor: "rgba(255, 255, 255, 1)",
    boxShadow: "0px 4px 10px 0px rgba(0, 0, 0, 0.05)",
  },
  inputLabel: {
    fontSize: "18px",
    fontWeight: "500",
    fontFamily: "Satoshi",
    color: "rgba(39, 39, 39, 1)",
    transform: "translateY(60%)",
  },
  loginWithOtp: {
    fontFamily: "Plus Jakarta Sans",
    alignSelf: "end",
    fontSize: "1rem",
    fontWeight: "500",
    color: "rgba(36, 84, 255, 1)",
    textDecoration: "none",
    [theme.breakpoints.down("sm")]: {
      margin: "2px auto",
    },
  },
  button: {
    margin: "25px 0",
    width: "100%",
    fontWeight: "800",
    fontSize: "16px",
    FontFamily: "Plus Jakarta Sans",
    height: "51px",
    textTransform: "none",
    borderRadius: "6px",
    backgroundColor: "rgba(255, 167, 35, 1)",
    color: "rgba(255, 255, 255, 1)",
    "&:hover": {
      backgroundColor: "rgba(255, 167, 35, 1)",
    },
  },
  inputText: {
    fontSize: "15px",
    FontFamily: "Satoshi",
    fontWeight: "500",
  },
  inputFieldWithIcon: {
    display: "flex",
    alignItems: "center",
  },
  icon: {
    color: "rgba(202, 202, 202, 1)",
  },
  passwordInput: {
    display: "flex",
    margin: "15px 0",
    width: "100%",
  },
}));

function ParikshadoAdmin({ onLogin }) {
  const classes = useStyles();
  const navigate = useNavigate();

  const [showPassword, setShowPassword] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isSubmitClicked, setIsSubmitClicked] = useState(false);
  const [formError, setFormError] = useState({});
  const [error, setError] = useState("Please enter your detail");
  const [errmsg, setErrMsg] = useState("");
  const [pageURL, setPageURL] = useState("");

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    setPageURL(window.location.href);
  }, []);

  const urlParams = new URLSearchParams(pageURL.split("?")[1]);
  const token = urlParams.get("token");
  const userName = urlParams.get("userName");
  console.log(
    "token123456",
    token,
    userName,
    urlParams,
    urlParams.get("userName")
  );
  useEffect(() => {
    if (token && userName) {
      // sessionStorage.setItem('token', token);
      // sessionStorage.setItem('userName', userName);

      const encryptedToken = encryptData(token);
      const encryptedUser = encryptData(userName);

      sessionStorage.setItem("token", encryptedToken);
      sessionStorage.setItem("userName", encryptedUser);

      onLogin();
      navigate("/admin/dashboard");
    }
  }, [token, userName, onLogin, navigate]);

  useEffect(() => {
    if (isSubmitClicked && Object.keys(formError).length === 0) {
      axios({
        method: "post",
        url: `${process.env.REACT_APP_API_BASE_URL}/v1/client/centers/auths/signin`,
        data: {
          user: {
            username: email,
            password: password,
          },
        },
      }).then(
        (response) => {
          if (response.data.success === true) {
            const encryptedToken = encryptData(response.data.token);

            const username = response.data.user.first_name;

            const encryptedUser = encryptData(username);
            sessionStorage.setItem("token", encryptedToken);
            sessionStorage.setItem("id", response.data.user.id);
            sessionStorage.setItem("userName", encryptedUser);

            onLogin();
            navigate("/admin/dashboard");
          }
        },
        (error) => {
          sessionStorage.clear();
          setIsSubmitClicked(false);
          setError(error?.response?.data?.message);
          setErrMsg(error?.response?.data?.message);
        }
      );
    } else {
      console.log(formError);
      setIsSubmitClicked(false);
    }
  }, [isSubmitClicked, formError, email, password, onLogin, navigate]);

  const validateForm = () => {
    const errors = {};

    // Email validation
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    // if (email.length === 0) {
    //   errors.email = "Email is required";
    // } else if (!emailRegex.test(email)) {
    //   errors.email = "Invalid email format";
    // }
    const phoneRegex = /^\d{10}$/;

    if (email.length === 0) {
      errors.email = "Phone number is required";
    } else if (!phoneRegex.test(email)) {
      errors.email = "Invalid phone number format";
    }

    // Password validation (at least 8 characters)
    if (password.length === 0) {
      errors.password = "Password is required";
    } else if (password.length < 6) {
      errors.password = "Password must be at least 6 characters";
    }

    return errors;
  };

  const handleSubmit = () => {
    const formErrors = validateForm();

    // Check if there are any errors
    if (Object.keys(formErrors).length === 0) {
      // If no errors, proceed with form submission
      setIsSubmitClicked(true);
      setFormError({});
      console.log(formError, "true");
      // Your existing code for submitting the form
    } else {
      // If there are errors, update the state to display them
      setFormError(formErrors);
      console.log(formError, "false");
      setIsSubmitClicked(false);
    }
  };

  return (
    <Card className={classes.card}>
      <div className={classes.backgroundContainer}>
        <div className={classes.textContainer}>
          <Typography variant="h3" className={classes.heading}>
            Welcome Back!
          </Typography>
          <Typography variant="h4" className={classes.Subheading}>
            Local Client Admin Panel
          </Typography>
        </div>
      </div>
      <CardContent className={classes.content}>
        <Paper className={classes.additionalCard}>
          <Grid
            container
            direction="column"
            alignItems="center"
            justifyContent="center"
          >
            <Typography variant="h4" className={classes.signInText}>
              Sign In To Continue
            </Typography>
            <div className={classes.inputContainer}>
              <Typography className={classes.inputLabel}>
                Enter Phone Number
              </Typography>
              <TextField
                placeholder="+91 9876543210"
                className={classes.inputField}
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                }}
                variant="outlined"
                InputProps={{
                  classes: {
                    input: classes.inputText,
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton className={classes.icon}>
                        <PhoneIcon />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Link
                variant="subtitle1"
                className={classes.loginWithOtp}
                onClick={() => {
                  // console.log("Requesting OTP for email:", email);
                  axios({
                    method: "post",
                    url: `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/client/auth/signin_with_otp`,
                    data: {
                      user: {
                        username: email,
                      },
                    },
                  }).then(
                    (response) => {
                      console.log("OTP response:", response.data);
                      navigate(`/otpscreen/${email}`);
                      // handle the response data as needed
                    },
                    (error) => {
                      console.error(
                        "OTP request failed:",
                        error.response.data.message
                      );
                      // handle the error as needed
                    }
                  );
                }}
              >
                Login With OTP
              </Link>
              <Typography className={classes.inputLabel}>
                Enter Password
              </Typography>
              <TextField
                placeholder="Password"
                className={classes.passwordInput}
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                }}
                variant="outlined"
                type={showPassword ? "text" : "password"}
                InputProps={{
                  classes: {
                    input: classes.inputText,
                  },
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={togglePasswordVisibility}>
                        {showPassword ? (
                          <VisibilityIcon />
                        ) : (
                          <VisibilityOffIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Button onClick={handleSubmit} className={classes.button}>
                {" "}
                Login
              </Button>
            </div>
          </Grid>
        </Paper>
        <Typography className={classes.versionText}>
          Version 1.0.2 | Dated - 6 NOV 2025
        </Typography>
      </CardContent>
    </Card>
  );
}

export default ParikshadoAdmin;
